module.exports = __webpack_public_path__ + "static/media/49_B.5e8e22e3.png";